module.exports = __webpack_public_path__ + "img/Close.244ae86d.svg";